<template>
  <div>
    <populate-form
      class="QQ"
      formTitle="票券狀態報表"
      fkey="sr01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
    ></populate-form>
    <loading
     :show="Loading.show"
     :label="Loading.label">
    </loading>
  </div>
</template>

<script>

import { 
  apiGetReportDownloadUrl,
 } from '@/api/SalesManage.js'

import {
  apiDownloadFile
} from '@/api/Util.js'

import loading from 'vue-full-loading'
import axios from 'axios'

export default {
  name: 'SalesViewTicketStatus',
  components: {
    loading,
  },
  data: function () {
    return {
      filterData: {},
      // 別寫這 之後搬到created或mounted裡,可以處理時間差載入傳下去的資料
      filterOptions: [
        {
          'componentType':'date-picker',
          'title':'起始日',
          'placeholder':'起始日',
          'defaultValue':null,
          'akey':'start_at',
          'col':6,
          'isRequired':true
        },
        {
          'componentType':'date-picker',
          'title':'結束日',
          'placeholder':'結束日',
          'defaultValue':null,
          'akey':'end_at',
          'col':6,
          'isRequired':true
        },
        {
          'componentType':'text',
          'defaultValue':'',
          'akey':'supplier',
          'col':6,
          'placeholder':'供應商 填名稱或id都可以 e.g. 蜜達絲生技有限公司 or SU20170207000002',
        },
        {
          'componentType':'vue-single-select',
          'akey':'date_type',
          'dataOptions':['依回兌時間篩選','依印票時間篩選', '依使用時間篩選', '依取消時間篩選', '建立時間 (進到票券系統時間)'],
          'defaultValue': '依印票時間篩選',
          'col':3,
          'placeholder':"依印票時間篩選",
          'isRequired':true
        },
        {
          'componentType':'b-button',
          'placeholder':'下載報表',
          'akey':'search',
          'col':3,
          'execCallback':this.getDownloadPath
        },
      ],
      Loading: {
        'show': false,
        'label': '取得資料中'
      },
    }
  },
  props: [
    ],
  methods: {
    getDownloadPath: async function() {
        console.log('?')
        console.log(this.filterData)

        if (this.filterData.start_at === undefined){
          alert('請填起始日')
          return
        }

        if (this.filterData.end_at === undefined){
          alert('請填結束日')
          return
        }

        let date_type = ''
        switch (this.filterData.date_type) {
          case '依回兌時間篩選':
            date_type = 'writeoff_time'
            break
          case '依印票時間篩選':
            date_type = 'print_time'
            break
          case '依使用時間篩選':
            date_type = 'confirm_use_time'
            break
          case '依取消時間篩選':
            date_type = 'cancel_time'
            break
          case '建立時間 (進到票券系統時間)':
            date_type = 'created_at'
            break
        }
        
        if (this.filterData.supplier === undefined){
          this.filterData.supplier = ''
        }

        console.log(date_type)

        let param = {
          "date_type": date_type,
          "start_at": this.filterData.start_at,
          "end_at": this.filterData.end_at,
          "supplier": this.filterData.supplier
        }

        console.log(param)
        this.Loading.show = true
        let that = this
        let result = await apiGetReportDownloadUrl(param).then(function(resp){
          return resp
        }).catch(function(error){
          // that.Loading.show = false
          let data = error.response.data
          that.$bus.fnShowInfo(data.msg)
        })

        this.Loading.show = false

        console.log(result)
        if (!result) {
          return
        }

        let data = result.data.data
        
        // 下載檔案
        data.url = process.env.VUE_APP_API_ENDPOINT + data.url.replace('/api/ticket', '')
        let file_name =  this.filterData.start_at + '_' +  this.filterData.end_at + '_' + this.filterData.supplier

        apiDownloadFile(data.url).then(function(resp){
          let data = resp.data
          const url = window.URL.createObjectURL(new Blob([resp.data], {type:'application/vnd.ms-excel'}));
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', file_name + '.xlsx');
          document.body.appendChild(link);
          link.click();
          console.log(resp.data)
        }).catch(function(error){
          let data = error.response.data
          that.$bus.fnShowInfo(data.msg)
        })
        
    }
  },
  computed: {
  },
  mounted () {
    // 判斷role,總管理就直接用admin抓,若商家的話...則判斷是總管理或分店
    // const role = this.$bus.getRole()
    // if (role === 'user') {
    //   return
    // } else if (role === 'merchant') {
    //   this.isAdmin = false
    //   if (this.$bus.session) {
    //     if (this.$bus.session.is_super_manage) {
    //       this.currentLayer = 'merchant'
    //       this.merchant_id = this.$bus.session.merchant_id
    //       this.current_merchant_name = this.$bus.session.merchant_name
    //       this.stackItems = [{
    //         'layer_name':'商家數據('+this.$bus.session.merchant_name+')',
    //         'target':'merchant'
    //       }]
    //     }
    //     else {
    //       this.currentLayer = 'store'
    //       this.store_id = this.$bus.session.merchant_store_id
    //       this.store_login_merchant_id = this.$bus.session.merchant_id
    //       this.current_store_name = this.$bus.session.store_name
    //       this.stackItems = [{
    //         'layer_name':'分店數據('+this.$bus.session.store_name+')',
    //         'target':'store'
    //       }]

    //     }
    //     this.$refs.filterForm.initDefault()
    //   }
    //   else {
    //     return
    //   }
    // }
    // this.refreshControl()
    // this.getChartData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chart1 {
  width:80%;
  height:280px;
}
.summary1 {
  width:20%;
  margin-left: -5%;
  margin-top:auto;
  margin-bottom:auto;
}
.fun-label {
  margin-top:1px;
  margin-left:1px;
  background-color:lavender;
  box-shadow: 5px 5px 5px;
  margin-right:5px;
}
.fun-label >>> a {
  color:darkblue;
  text-decoration: underline;
}
.current-label {
  cursor:none;
}
.current-label >>> a {
  cursor:not-allowed;
  color:black;
  font-size: medium;
  text-decoration: none;
}

.font-small {
  font-size: 10px;
}
</style>
